<template>
    <div v-loading="loading" element-loading-text="查询中..." v-cloak>
        <el-select style="width: 320px;" v-if="enableSearch != null && enableSearch == true && enableUseSearch" clearable v-model="searchUseIdx" placeholder="用途标签" class="mt5 mb10" @change="handleFilterTextClick">
            <el-option v-for="item in categUseTypeList" :label="item.text" :value="item.value"></el-option>
        </el-select>
        <el-input style="width: 320px;" v-if="enableSearch != null && enableSearch == true" class="mt5 mb10" placeholder="输入关键字进行过滤" v-model="filterText">
            <!--<i slot="suffix" class="el-input__icon el-icon-search" @click="handleFilterTextClick"></i>-->
        </el-input>
        <a class="swb-btn swb-btn-primary swb-btn-mini" @click="handleFilterTextClick">查询</a>
        <el-radio-group v-if="!isClickEvent" v-model="checkCatId" style="display: block">
            <el-tree class="filter-tree" ref="categTree" :data="dataList" :load="loadNode" lazy="" node-key="id" :filter-node-method="filterNode" :highlight-current="highlightCurrent" @node-click="clickNode" :props="defaultProps" :render-content="renderContent" :default-expanded-keys="openNodeKeys"></el-tree>
        </el-radio-group>
        <div v-else>
            <el-tree style="width: 320px;" class="filter-tree" ref="categTree" :data="dataList" :load="loadNode" lazy="" node-key="id" :filter-node-method="filterNode" :highlight-current="highlightCurrent" @node-click="clickNode" :props="defaultProps" :render-content="renderContent" :default-expanded-keys="openNodeKeys"></el-tree>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, filterByName, Routes } from '../../app.vues'

    import goodsCategApi from '../../api/goodsCateg'

    export default {
        name: 'swb-categ-tree',
        desc: '商品分类树列表',
        props: {
            enableSearch: {
                type: Boolean,
                default: null
            },
            enableUseSearch: {
                type: Boolean,
                default: true
            },
            searchUseId: {
                type: Number,
                default: null
            },
            isClickEvent: {
                type: Boolean,
                default: true
            },
            isRadio: {
                type: Boolean,
                default: false
            },
            noPostFilters: { // 是否不要进行岗位权限过滤
                type: Boolean,
                deafult: false,
            }
        },
        watch: {},
        data: function () {
            return {
                loading: false,
                highlightCurrent: true,
                filterText: "",
                defaultProps: {
                    children: 'goodsCatSons',
                    label: 'name'
                },
                checkCatId: null,
                checkCatItem: {},
                //
                dataList: [],
                openNodeKeys: [],
                isLoadNode: true,
                initCatList: [],
                initLazyCatList: [],
                categUseTypeList: getEnumList('categUseType'),
                searchUseIdx: null
            }
        },
        created: function () {
            this.getGoodsCatTreeListByFilter();
        },
        methods: {
            handleFilterTextClick: function () {
                let filterText = this.filterText;
                let searchUseIdx = this.searchUseIdx;
                if(Utils.isNoB(filterText) && Utils.isNoB(searchUseIdx)) {
                    this.defaultExpandedKeys = [];
                    this.isLoadNode = true;
                    this.dataList = Utils.merge([], this.initLazyCatList);
                } else {
                    this.isLoadNode = false;
                    let initCatList = Utils.merge([], this.initCatList);
                    let nodeKey = [];
                    if(!Utils.isNoB(filterText)) {
                        this.dataList = filterByName(initCatList, filterText, "goodsCatSons", true, nodeKey, "id");
                    }
                    if(!Utils.isNoB(searchUseIdx)) {
                        if(!Utils.isNoB(filterText)) {
                            let dataList = Utils.merge([], this.dataList);
                            this.dataList = filterByName(dataList, searchUseIdx, "goodsCatSons", true, nodeKey, "id", ['useId']);
                        } else {
                            this.dataList = filterByName(initCatList, searchUseIdx, "goodsCatSons", true, nodeKey, "id", ['useId']);
                        }
                    }
                    this.openNodeKeys = Utils.merge([], nodeKey);
                }
            },
            getCategList(){
                let self = this;
                let postData = {};
                let filterItems = {};
                filterItems.noPostFilters = this.noPostFilters;
                postData.filterItems = filterItems;
                let theLoading = MsgBox.loading();
                goodsCategApi.getGoodsCatTreeList(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        self.dataList = result.data;
                        self.initLazyCatList = result.data;
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            getGoodsCatTreeListByFilter: function () {
                let self = this;
                let postData = {};
                postData.noPostFilters = this.noPostFilters;
                let theLoad = MsgBox.loading();
                goodsCategApi.getGoodsCatTreeListByFilter(postData, function (result, jqXhr) {
                    if(result.type == 'info') {
                        self.initCatList = result.data;
                        if(self.searchUseId != null) {
                            self.searchUseIdx = parseInt(self.searchUseId + '');
                            self.handleFilterTextClick();
                        }
                    } else {
                        self.$message.error(result.message);
                    }
                    theLoad.hide();
                });
            },
            loadNode(node, resolve) {
                let self = this;
                let dbChildren = node.data.goodsCatSons || [];
                if(node.level === 0) {
                    this.getCategList();
                } else {
                    if(node.level >= 3) return resolve([]);
                    let parentId = node.data.id;
                    let postData = {};
                    let filterItems = {};
                    filterItems.parentId = parentId;
                    filterItems.noPostFilters = this.noPostFilters;
                    postData.filterItems = filterItems;
                    //
                    if(this.isLoadNode == true) {
                        goodsCategApi.getGoodsCatTreeList(postData, function (result) {
                            if(result.type == 'info') {
                                resolve(result.data);
                            } else {
                                resolve([]);
                                self.$message.warning(result.message);
                            }
                        });
                    } else {
                        resolve(dbChildren);
                    }
                }
            },
            filterNode(value, data) {
                if(!value) {
                    return true;
                }
                return data.name.indexOf(value) !== -1;
            },
            renderContent: function (createElement, node) {
                //设置叶子节点标记（不然会出现多余的箭头）
                node.node.isLeaf = node.data.leafFlag;
                //
                let selfTree = this;
                return createElement({
                    data: function () {
                        return {
                            item: node,
                            checkCatId: selfTree.checkCatId,
                            isClickEvent: selfTree.isClickEvent,
                            categUseTypeMap: getEnumMap("categUseType", "value2text")
                        };
                    },
                    template: '' +
                    '<span v-if = "isClickEvent == false">' +
                    '   <el-radio v-if = "item.data.level >= 3" class = "radio" v-model="checkCatId" :label="item.data.id">' +
                    '       <span>{{item.data.name}}</span>' +
                    '       <el-tag class="ml5" type="gray" v-if="item.data.useId != null">{{categUseTypeMap[item.data.useId]}}</el-tag>' +
                    '   </el-radio>' +
                    '   <span v-else>{{item.data.name}}</span>' +
                    '</span>' +
                    '<span v-else-if="isClickEvent == true">' +
                    '<span>{{item.data.name}}</span>' +
                    '</span>',
                    methods: {}
                });
            },
            clickNode(data) {
                //
                let checkCatItem = {};
                checkCatItem.id = data.id;
                checkCatItem.name = data.name;
                checkCatItem.fullName = data.fullName;
                checkCatItem.level = data.level;
                checkCatItem.parentId = data.parentId;
                checkCatItem.unit = data.unit;
                checkCatItem.catId1 = data.catId1;
                checkCatItem.catId2 = data.catId2;
                checkCatItem.catId3 = data.catId3;
                checkCatItem.hasSpec = data.hasSpec;
                checkCatItem.hasColor = data.hasColor;
                checkCatItem.colorGroupId = data.colorGroupId;
                checkCatItem.hasBrand = data.hasBrand;
                checkCatItem.brandGroupId = data.brandGroupId;
                //
                let isClickEvent = this.isClickEvent;
                if(isClickEvent == false) {
                    if(data.level >= 3) {
                        //
                        this.checkCatId = data.id;
                        this.checkCatItem = checkCatItem;
                    }
                } else {
                    this.checkCatItem = checkCatItem;
                    this.notityChange();
                }

            },
            notityChange: function () {
                // 发生变化时向上传递
                this.$emit('notity-change', this.checkCatItem);
            },
            getDlgResult(){
                let self = this;
                let result = {};
                if(this.checkCatId != null) {
                    result.type = 'info';
                    result.data = self.checkCatItem;
                } else {
                    result.type = 'warn';
                    result.message = '请选择分类';

                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/categ/CategTree.vue